import React from 'react';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: '36px!important',
  fontWeight: 800,
  lineHeight: '45px',
  letterSpacing: '0.25px',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
  textAlign: 'center',
  whiteSpace: 'pre-line',
  overflowWrap: 'anywhere',
  [theme.breakpoints.down('md')]: {
    fontSize: '28px!important',
  },
}));

const OverlineTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  fontSize: '12px',
  lineHeight: '32px',
  letterSpacing: '1px',
  textAlign: 'center',
  marginTop: theme.spacing(2),
}));

function TextBoldHighlight(props) {
  const { heading, overline } = props;
  if (!heading && !overline) return null;
  return (
    <Grid container alignItems='center' flexDirection='column'>
      {overline && (
        <Grid item>
          <OverlineTypography variant='overline' component='div'>
            {overline}
          </OverlineTypography>
        </Grid>
      )}
      {heading && (
        <Grid item>
          <TitleTypography variant='h3'>
            {heading}
          </TitleTypography>
        </Grid>
      )}
    </Grid>
  );
}

export default TextBoldHighlight;
